import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    if (!window.location.href.includes("/blockchain_calculations")) return;

    this.span = document.getElementById("select2-contract_customer_id-container");
    this.walletSelect = document.getElementById("contract_existing_wallet_address");

    if (!this.span || !this.walletSelect) return;

    this.walletSelect.innerHTML = "";

    this.lastValue = null;

    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "childList") {
          const value = mutation.target.textContent.trim();
          if (value && value !== this.lastValue) {
            this.lastValue = value;
            this.updateSelect(value);
          }
        }
      });
    });

    this.observer.observe(this.span, { childList: true });

    this.handleWalletAddressUpdate = (e) => {
      const value = e.target.textContent.trim();
      if (value && value !== this.lastValue) {
        this.lastValue = value;
        this.updateSelect(value);
      }
    };

    this.span.addEventListener("updateWalletAddress", this.handleWalletAddressUpdate);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
    if (this.span && this.handleWalletAddressUpdate) {
      this.span.removeEventListener("updateWalletAddress", this.handleWalletAddressUpdate);
    }
  }

  updateSelect(value) {
    this.updateWalletInput(value).then((addresses) => {
      this.walletSelect.innerHTML = "";

      if (!addresses || addresses.length === 0) {
        const option = document.createElement("option");
        option.textContent = "Keine Wallet-Adresse verfügbar";
        option.disabled = true;
        this.walletSelect.appendChild(option);
        return;
      }

      addresses.forEach((address) => {
        const option = document.createElement("option");
        option.value = address;
        option.textContent = address;
        this.walletSelect.appendChild(option);
      });
    });
  }

  async updateWalletInput(value) {
    const customerId = value.split(" ")[0].replace("#", "");
    const response = await fetch(`/customers/customers_wallet_addresses.json?customer_id=${customerId}`);
    if (!response.ok) {
      console.error("Failed to fetch wallet addresses:", response.status);
      return [];
    }
    return response.json();
  }
}
